import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";
import { useTranslation } from "react-i18next";

export default function Login() {
  const { t } = useTranslation();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success(t("login_title"));
      if (u.role === "landlord") navigate("/landlord");
      else if (u.role === "investor") navigate("/portfolio");
      else if (u.role === "amc") navigate("/amc");
      else navigate("/tenant");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] grid grid-cols-12">
      <div className="col-span-12 md:col-span-5 flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6">
          <div>
            <div className="font-mono-label text-[11px] text-[#002FA7]">⎯⎯ {t("login_tag")}</div>
            <h1 className="font-display text-4xl font-black mt-2">{t("login_title")}</h1>
          </div>
          <div className="space-y-3">
            <Label className="font-mono-label text-[10px]">{t("login_email")}</Label>
            <Input data-testid="login-email" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} className="rounded-none h-11"/>
            <Label className="font-mono-label text-[10px]">{t("login_password")}</Label>
            <Input data-testid="login-password" type="password" required value={password}
              onChange={(e) => setPassword(e.target.value)} className="rounded-none h-11"/>
          </div>
          <Button data-testid="login-submit" disabled={busy} className="w-full rounded-none bg-black hover:bg-zinc-800 h-11 font-mono-label text-xs">
            {busy ? t("processing") : t("login_submit")}
          </Button>
          <div className="text-sm text-zinc-600">
            {t("login_no_account")} <Link to="/register" className="text-[#002FA7] underline">{t("login_create")}</Link>
          </div>
        </form>
      </div>
      <div className="hidden md:block col-span-7 bg-black relative overflow-hidden">
        <img src="https://images.unsplash.com/photo-1567943183748-3a7542120c90?w=1200" alt="" className="w-full h-full object-cover opacity-70" />
        <div className="absolute bottom-10 start-10 text-white max-w-md">
          <div className="font-mono-label text-[10px] text-[#FFCC00]">⎯⎯ {t("brand")}</div>
          <div className="font-display text-3xl font-black mt-3 leading-tight">
            {t("hero_sub")}
          </div>
        </div>
      </div>
    </div>
  );
}
